import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useBetaSignup } from '../context/BetaSignupContext';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { openModal } = useBetaSignup();

  const isActive = (path) => location.pathname === path;

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Offerings', path: '/offerings' },
    { name: 'About', path: '/about' },
    { name: 'Blog', path: '/blog' }
  ];

  const handleGetStarted = () => {
    openModal();
    setMobileMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#F5F3ED] border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <span className="text-2xl tracking-tight font-light" style={{ fontFamily: 'Georgia, serif', color: '#1a1a3e' }}>
              trove<span style={{ color: '#FF8C42' }}>.</span>
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-12">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-light transition-colors hover:text-[#1a1a3e] ${
                  isActive(link.path) ? 'text-[#1a1a3e] font-medium' : 'text-gray-600'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Desktop CTA Button - Only Get Started (Sign In removed) */}
          <div className="hidden md:flex items-center">
            <Button 
              onClick={handleGetStarted}
              size="sm" 
              className="bg-[#1a1a3e] hover:bg-[#252550] rounded-full px-6 font-light"
              data-testid="navbar-get-started-btn"
            >
              Get Started
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-btn"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t border-gray-200 bg-[#F5F3ED]">
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block py-2 text-sm font-light ${
                  isActive(link.path) ? 'text-[#1a1a3e] font-medium' : 'text-gray-600'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.name}
              </Link>
            ))}
            <div className="pt-4">
              <Button 
                onClick={handleGetStarted}
                className="w-full bg-[#1a1a3e] hover:bg-[#252550] rounded-full font-light"
                data-testid="mobile-get-started-btn"
              >
                Get Started
              </Button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
